import React, { MouseEvent } from "react";
import { Stack } from "web/react/emo/shared/components/stack";
import { Text } from "web/react/emo/text";
import { useDomViewport } from "web/react/hooks/use-dom-viewport/use-dom-viewport";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./storefront-description.css";

const ANALYTICS_CATEGORIES = ["product_area"];

export interface StorefrontDescriptionProps {
    analyticsCategory?: (typeof ANALYTICS_CATEGORIES)[number];
    productId?: string;
    description?: string | null;
    beforeOnClick?: () => void;
}

export function StorefrontDescription({
    analyticsCategory,
    productId,
    description,
    beforeOnClick,
}: StorefrontDescriptionProps): JSX.Element {
    const { isMobileViewport } = useDomViewport();

    const moreButtonText = `...${gettext("general.more").toLowerCase()}`;
    const descriptionContent = !description ? gettext("general.learn_more_seller") : description;

    const onClick = (e: MouseEvent): void => {
        beforeOnClick?.();
        const target = e.target as HTMLElement;
        // TODO: implement new analytics
        if (target.tagName.toLowerCase() === "a") {
            return;
        }
        if (analyticsCategory) {
            analytics.event(
                analyticsCategory,
                "click",
                "open-details",
                false,
                {
                    product_id: productId,
                },
                "",
                {},
                [],
                false,
                false
            );
        }
    };

    return (
        <div
            onClick={onClick}
            data-testid="storefront-description"
            className={styles.descriptionContainer}
        >
            <Stack direction={"row"} align={"end"}>
                <Text
                    textStyle={{ sm: "body-s", md: "body" }}
                    lineLimit={isMobileViewport ? 3 : 2}
                    dataTestId="storefront-description-text"
                >
                    {descriptionContent}
                </Text>
                <span className={description ? styles.fadeOverlay : styles.noOverlay}>
                    <button
                        data-testid="storefront-description-button"
                        className={styles.moreButton}
                    >
                        <Text textStyle={{ sm: "body-s-bold", md: "body-bold" }}>
                            {moreButtonText}
                        </Text>
                    </button>
                </span>
            </Stack>
        </div>
    );
}
